import { AbstractCameraRig } from "./AbstractCameraRig";
/**
 * Controls the suspensful incremental camera zoom-in and swelling shake effect during the scatter pick game.
 */
export class ScatterPickTapCameraRig extends AbstractCameraRig {
    create() {
        super.create();
        this.progress = 0;
        this.shake = 0;
    }
    handleRotate() {
        super.handleRotate();
        this.applyZoom();
        this.applyShake();
    }
    async playTap() {
        // If this is the first pick, start the shake effect.
        if (this.model.getPickTaps() === 1) {
            this.shakeTween?.kill();
            this.shakeTween = gsap.to(this, {
                yoyo: true,
                repeat: Infinity,
                shake: 1,
                duration: 0.1,
                ease: "sine.inOut",
                onUpdate: () => this.applyShake(),
            });
            this.progress = 0;
        }
        // If this is the last pick, fade the shake effect out.
        if (this.model.getPickTaps() >= this.model.getPickTapsRequired()) {
            this.shakeTween?.kill();
            this.shakeTween = gsap.to(this, {
                shake: 0,
                duration: 2,
                onUpdate: () => this.applyShake(),
            });
        }
        // Zoom in to the current progress once the player has tapped.
        this.zoomTween?.kill();
        this.zoomTween = gsap.to(this, {
            progress: this.model.getPickTaps() / this.model.getPickTapsRequired(),
            duration: 0.4,
            ease: "back.out(10)",
            onUpdate: () => this.applyZoom(),
        });
        await this.zoomTween;
        // Zoom out the camera to the previous progress while the player isn't tapping.
        this.zoomTween = gsap.to(this, {
            progress: Math.max(this.model.getPickTaps() - 1, 0) / this.model.getPickTapsRequired(),
            duration: 15,
            ease: "power4.inOut",
            onUpdate: () => this.applyZoom(),
        });
    }
    applyZoom() {
        const zoomProgress = this.getEasedProgress("power1.in");
        const zoomScale = this.uiProperties.scatterPickZoomStart + (this.uiProperties.scatterPickZoomEnd - this.uiProperties.scatterPickZoomStart) * zoomProgress;
        this.scale.set(zoomScale);
    }
    applyShake() {
        this.recentreFocus();
        const shakeProgress = this.getEasedProgress("power4.in");
        const shakeMagnitude = this.shake * this.uiProperties.scatterPickShake * shakeProgress;
        const shakeAngle = Math.random() * Math.PI * 2;
        this.x += shakeMagnitude * Math.cos(shakeAngle);
        this.y += shakeMagnitude * Math.sin(shakeAngle);
    }
    getEasedProgress(ease) {
        // Ease the range 0 to 1.
        const eased = gsap.parseEase(ease)(Math.min(this.progress, 1));
        if (this.progress <= 1) {
            return eased;
        }
        // Ease the overshoot, reflected around 1 to keep the curve smooth.
        const overshoot = 1 - gsap.parseEase(ease)(Math.max(2 - this.progress, 0));
        return eased + overshoot;
    }
}
//# sourceMappingURL=ScatterPickTapCameraRig.js.map